@if (profileField$ | async; as profileField) {
  @if (childDefinition$ | async; as childDefinition) {
    @switch (childDefinition?.Type) {
      @case (FieldType.ThesaurusField) {
        <med-thesaurus-field
          [profileField]="profileField"
          [thesaurusFieldDefinition]="childDefinition"
          [fieldInheritance]="_fieldInheritance"
          [records]="records$ | async"
          [control]="control$ | async"
          [multiple]="true"
          [disabledMessageKey]="disabledMessageKey"
          >
          <!-- Merge Strategy Component-->
          <ng-content></ng-content>
        </med-thesaurus-field>
      }
      @case (FieldType.PositionField) {
        <ng-container *ngTemplateOutlet="addressList; context: { profileField }"></ng-container>
      }
      @default {
        <ng-container [ngTemplateOutlet]="defaultComplexList"></ng-container>
      }
    }
  }
}

<ng-template #addressList let-profileField="profileField">
  <med-address-input-list
    [records]="records$ | async"
    [profileField]="profileField"
    [fieldInheritance]="_fieldInheritance"
    [control]="control$ | async"
    [errorMsg]="errorMsg$ | async"
    [autocompleteFct]="autocompleteFct"
    [subFieldAutocompleteFcts]="subFieldAutocompleteFcts"
    [isBatchEdit]="isBatchEdit"
    [nestedIndex]="nestedIndex$ | async"
  ></med-address-input-list>
</ng-template>

<ng-template #defaultComplexList>
  <sh-complex-list-field
    [profileField]="profileField$ | async"
    [records]="records$ | async"
    [fieldInheritance]="_fieldInheritance"
    [control]="control$ | async"
    [nestedIndex]="nestedIndex$ | async"
    [disabledMessageKey]="disabledMessageKey"
    [isBatchEdit]="isBatchEdit"
    >
    <!-- Merge Strategy Component-->
    <ng-content></ng-content>
  </sh-complex-list-field>
</ng-template>
